import { Log, LogFilter } from '@cloudio-saas/datasource-types';
import { atom } from '@cloudio-saas/statex';

export const openExamineDataAtom = atom({
  path: ['transient', 'header', 'openExamineData'],
  defaultValue: false,
});

export const examineDataAliasAtom = atom({
  path: ['transient', 'header', 'examineDataAlias'],
  defaultValue: '',
});

export const examineDataPageIdAtom = atom({
  path: ['transient', 'header', 'examineDataPage'],
  defaultValue: '',
});

export const openRecentSQLAtom = atom({
  path: ['transient', 'header', 'openRecentSQL'],
  defaultValue: false,
});

export const openAboutAtom = atom({
  path: ['transient', 'header', 'openAbout'],
  defaultValue: false,
});

export const recentSqlFilterAtom = atom({
  path: ['transient', 'header', 'sqlFilter'],
  defaultValue: '',
});

export const serverLogFilterAtom = atom({
  path: ['transient', 'header', 'serverLogFilter'],
  defaultValue: '',
});

export const serverLogsAtom = atom<Log[]>({
  path: ['transient', 'header', 'serverLogs'],
  defaultValue: [],
});

export const filteredServerLogsLiveAtom = atom<Log[]>({
  path: ['transient', 'header', 'filteredServerLiveLogs'],
  defaultValue: [],
});

const fromDate = new Date();
fromDate.setHours(fromDate.getHours() - 1, 0, 0, 0);

export interface LogFile {
  fileName: string;
  logEntries?: string[];
}

export const serverLogsRangeFilterAtom = atom<LogFilter>({
  path: ['transient', 'header', 'serverLogsRangeFilter'],
  defaultValue: {
    fromDate: fromDate,
    filter: '',
  },
});

export const serverLogsEntriesAtom = atom<LogFile[]>({
  path: ['transient', 'header', 'serverLogsEntries'],
  defaultValue: [],
});

export const serverLogsActiveEntryAtom = atom<LogFile | null>({
  path: ['transient', 'header', 'serverLogsActiveEntry'],
  defaultValue: null,
});

export const serverLogFiltersAtom = atom<Log>({
  path: ['transient', 'header', 'serverLogFilters'],
  defaultValue: {
    un: '',
    ds: '',
    m: '',
    t: 'Debug',
    ts: new Date().toISOString(),
  },
});

export const recentSqlAliasFilterAtom = atom({
  path: ['transient', 'header', 'sqlAliasFilter'],
  defaultValue: '',
});

export const showSystemSQLsAtom = atom({
  path: ['transient', 'header', 'showSystemSQLs'],
  defaultValue: false,
});

export const showExaminePropsAtom = atom({
  path: ['transient', 'header', 'showExamineProps'],
  defaultValue: { pageId: '', itemId: '', appUid: '' },
});

export const openViewDatasourceListAtom = atom({
  path: ['transient', 'header', 'openDatasourceList'],
  defaultValue: false,
});

export const viewDatasourcesUsedInfoAtom = atom<{
  pageId: string;
  pageName?: string;
}>({
  path: ['transient', 'header', 'viewDatasourcesUsedInfo'],
  defaultValue: { pageId: '' },
});
